import { createRootRoute, createRoute, createRouter } from '@tanstack/react-router';
import { YesqlPage } from './pages/YesqlPage';

/**
 * Code-based route tree (no file-based codegen step). YesQL is a single-screen
 * app, so there is exactly one route.
 */
const rootRoute = createRootRoute();

const indexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/',
  component: YesqlPage,
});

const routeTree = rootRoute.addChildren([indexRoute]);

export const router = createRouter({ routeTree });

// Register the router instance for full type inference on Links/navigation.
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
